import { Alert, Button, Col, Row } from "react-bootstrap";
import AntDTable from "../AntDTable/AntDTable";
import { Button as AntButton } from "antd";
import { getKonsultaReportsById, updateKonsultaReportById } from "../Helpers/API/PhilhealthApi/PhilhealthApi";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { RefreshRounded } from "@mui/icons-material";
import { capitalizeText, formatDateTime } from "../../Utils/Common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import BtnSave from "../Commons/Buttons/BtnSave";

export function KonsultaManager({ patientDetails }) {
  const [isLoading, setIsLoading] = useState(false);
  const [konsultaReports, setKonsultaReports] = useState([]);

  const updateKonsultaReport = async (row) => {
    if (row.report_status === "Validated") {
      toast.error("This eKonsulta report has already been validated and cannot be updated.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await updateKonsultaReportById(row.id);

      if (response && response.status !== 200) {
        console.error("Error response:", response.response.data);
        toast.error(response.response.data);
      } else {
        fetchKonsultaReports();
        toast.success("eKonsulta report updated successfully!");
      }
    } catch (error) {
      console.error("Error updating konsulta report:", error);
      toast.error("Failed to update eKonsulta report.");
    } finally {
      setIsLoading(false);
    }
  }

  const fetchKonsultaReports = async () => {
    setIsLoading(true);

    try {
      const response = await getKonsultaReportsById(patientDetails.id);

      if (response?.data) {

        const tableData = response.data.data.map((report) => {
          return {
            ...report,
            added_on: formatDateTime(report.added_on),
            report_status: capitalizeText(report.report_status),
            attachment: <EmbedXMLAttachment xml={report} />,
          };
        });

        setKonsultaReports(tableData);
      } else {
        console.error("No data found for konsulta reports");
      }
    } catch (error) {
      console.error("Error fetching konsulta reports:", error);
      toast.error("Failed to fetch eKonsulta reports.");
    }

    setIsLoading(false);
  }

  useEffect(() => {
    fetchKonsultaReports();
  }, []);

  function ActionBtn(row) {
    if (row.report_status === "Validated") return null

    return (
      <Row className="center">
        <Col>
          <BtnSave 
            id="edit"
            name="edit"
            label="Update"
            size="sm"
            onClick={() => updateKonsultaReport(row)}
          />
        </Col>
      </Row>
    )
  }
  
  if (patientDetails.ph_check !== '1') {
    return (
      <Alert
        variant="warning"
        className="d-flex align-items-center"
      >
        <FontAwesomeIcon
          fontSize={24}
          icon={faCircleExclamation}
        />
        <span className="px-3">
          Sorry, but you can't generate Philhealth reports without registering the patient's PhilHealth medical record.
        </span>
      </Alert>
    );
  }

  return (
    <main>
      <Row>
        <Col className="col-sm-9">
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <h5 className="font-bold">eKonsulta</h5>
            <AntButton
              type="text"
              className="px-2 m-0"
              onClick={fetchKonsultaReports}
              icon={<RefreshRounded />}
            />
          </div>
        </Col>
      </Row>
      <div className="row justify-content-center">
        <div className="col-sm-11 all-table">
          <AntDTable
            tableHeaders={[
              "ASSESSMENT DATE",
              "TRANCHE",
              "STATUS",
              "ATTACHMENT"
            ]}
            headerSelector={[
              "added_on",
              "tranche_number",
              "report_status",
              "attachment"
            ]}
            tableData={konsultaReports}
            loading={isLoading}
            scroll={{ x: true }}
            isClickable={false}
            searchExcluded={["attachment"]}
            withAction={true}
            ActionBtn={(row) => ActionBtn(row.row)}
          />
        </div>
      </div>
    </main> 
  )
}

function EmbedXMLAttachment({ xml }) {
  return (
    <>
      <div>
        <Button
          size="sm"
          variant="light"
          href={xml.url}
          target="_blank"  
        >
          {xml.filename}
        </Button>
      </div>
    </>
  );
}